import { render, staticRenderFns } from "./CourseSimple.vue?vue&type=template&id=33c09694&scoped=true"
import script from "./CourseSimple.vue?vue&type=script&lang=js"
export * from "./CourseSimple.vue?vue&type=script&lang=js"
import style0 from "./CourseSimple.vue?vue&type=style&index=0&id=33c09694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c09694",
  null
  
)

export default component.exports